import { SortEnum } from "@finway-group/shared/lib/consts/common"
import { PagingParams, QueryParamsFilter, typeHintFieldKey, type TypeHints } from "@finway-group/shared/lib/models/queryParams/queryParams.types"

export enum CacheEnum {
    ANALYTICS = "ANALYTICS",
    BILLING_SETTINGS = "BILLING_SETTINGS",
    BILLING_PRODUCTS_CARDS = "BILLING_PRODUCTS_CARDS",
    BILLING_INVOICE_CONSUMPTION = "BILLING_INVOICE_CONSUMPTION",
    BILLING_CARDS_COUNT = "BILLING_CARDS_COUNT",
    BILLING_INVOICES = "BILLING_INVOICES",
    EMPLOYEE = "EMPLOYEE",
    EMPLOYEES = "EMPLOYEES",
    NOTIFICATIONS = "NOTIFICATIONS",
    NOTIFICATIONS_COUNT = "NOTIFICATIONS_COUNT",
    EXPENSES = "EXPENSES",
    EXPENSES_MANY = "EXPENSES_MANY",
    VENDORS = "VENDORS",
    VENDORS_LIST = "VENDORS_LIST",
    VENDORS_MANY = "VENDORS_MANY",
    VENDORS_DROPDOWN = "VENDORS_DROPDOWN",
    PURCHASE_ORDERS = "PURCHASE_ORDERS",
    DELIVERY_NOTES = "DELIVERY_NOTES",
}

export const GENERAL_QUERY_STALE_TIME = 1 * 60 * 60 * 1000 // 1 hour in ms
export const GENERAL_QUERY_CACHE_TIME = 1 * 60 * 60 * 1000 // 1 hour in ms

export const VENDOR_DROPDOWN_FIELDS = "_id,name,isApproved,creditorNumber,img,deleted,dateDeleted"

export type QueryParams = {
    filter?: QueryParamsFilter
    search?: string
    /**
     * @deprecated Use sortParams instead
     */
    sortOption?: SortEnum
    /**
     * @deprecated Use sortParams instead
     */
    sortField?: string
    sortParams?: Array<{ sortField?: string; sortOption?: SortEnum }>
    [typeHintFieldKey]?: TypeHints
} & PagingParams
